module.exports = __webpack_public_path__ + "static/img/6.d6dea29.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/zh/6.png
// module id = fS9A
// module chunks = 0